import React, { RefObject, useEffect, useImperativeHandle } from "react";
import { useState } from "react";
import "./textField.scss";

interface TextFieldPropsType {
  passRef?: RefObject<any>;
  prefix?: any;
  suffix?: any;
  title?: string;
  maxWidth?: string | number;
  isFullWidth?: boolean;
  initialValue?: string;
  validator?: (text: string | undefined) => string | null;
  onChange?: (text: string) => void;
  onClick?: () => void;
  onBlur?: () => void;
  isSecure?: boolean;
  hideBorder?: boolean;
  padding?: string;
  fontSize?: string;
  placeHolder?: string;
  textAlignment?: "start" | "center";
  border?: string;
  color?: string;
  autoComplete?: string;
  disabled?: boolean;
  onClickCaption?: () => void;
  captionText?: string;
  extendable?: boolean;
  fontFamily?: string;
  height?: string;
}

const TextField = React.forwardRef<any, TextFieldPropsType>(
  (props: TextFieldPropsType, ref) => {
    const [focus, setFocus] = useState<boolean>(false);
    const [text, setText] = useState<string | undefined>(props.initialValue);

    useImperativeHandle(ref, () => ({
      validate(): boolean {
        if (!text) {
          setText("");
          return props.validator?.("") == null;
        }
        return props.validator?.(text) == null;
      },
    }));

    useEffect(() => {
      setText(props.initialValue);
    }, [props.initialValue]);

    const textFieldClass = [
      "textField",
      props.validator?.(text) ? "textFieldError" : "",
      props.validator?.(text) && focus ? "textFieldErrorFocus" : "",
      !props.border && focus ? "textFieldFocus" : "",
    ].join(" ");

    return (
      <div
        className={"textFieldContainer"}
        style={{
          width: !props.isFullWidth ? "" : "100%",
          maxWidth: props.maxWidth,
        }}
        onClick={props.onClick}
      >
        {(props.title || props.captionText) && (
          <div className="textfield-title-container">
            {props.title && <p className="textfield-title">{props.title}</p>}
            <p className="textfield-caption" onClick={props.onClickCaption}>
              {props.captionText}
            </p>
          </div>
        )}
        <div
          className={textFieldClass}
          style={{
            border: props.disabled
              ? "2px solid rgba(0,0,0,0.1)"
              : props.border != null
              ? props.border
              : props.hideBorder
              ? "none"
              : undefined,
            padding: props.extendable ? "0 0 0 5px" : props.padding,
          }}
        >
          {props.prefix && <div className={"suffix"}>{props.prefix}</div>}
          {props.extendable ? (
            <textarea
              disabled={props.disabled}
              autoComplete={props.autoComplete}
              value={text ?? ""}
              className={"input"}
              style={{
                cursor: props.disabled ? "not-allowed" : undefined,
                fontSize: props.fontSize,
                textAlign: props.textAlignment,
                color: props.color,
                height: props.height,
              }}
              onFocus={() => setFocus(true)}
              onBlur={() => {
                setFocus(false);
                props.onBlur?.();
              }}
              onChange={(e) => {
                setText(e.target.value);
                props.onChange?.(e.target.value);
              }}
              placeholder={props.placeHolder}
            />
          ) : (
            <input
              disabled={props.disabled}
              autoComplete={props.autoComplete}
              value={text ?? ""}
              className={"input"}
              style={{
                cursor: props.disabled ? "not-allowed" : undefined,
                fontSize: props.fontSize,
                textAlign: props.textAlignment,
                color: props.color,
                fontFamily: props.fontFamily,
              }}
              onFocus={() => setFocus(true)}
              onBlur={() => {
                setFocus(false);
                props.onBlur?.();
              }}
              onChange={(e) => {
                setText(e.target.value);
                props.onChange?.(e.target.value);
              }}
              type={props.isSecure ? "password" : "text"}
              placeholder={props.placeHolder}
            />
          )}
          {props.suffix && <div className={"suffix"}>{props.suffix}</div>}
        </div>
        {props.validator?.(text) && (
          <p className={"errorText"}>{props.validator?.(text)}</p>
        )}
      </div>
    );
  }
);
export default TextField;
